import React from 'react';
export const GrassDivider = ({
  className = '',
  fill = '#F0F5F1',
  position = 'bottom'
}) => <div className={`absolute left-0 right-0 w-full overflow-hidden leading-none z-20 pointer-events-none ${position === 'bottom' ? 'bottom-0' : 'top-0 rotate-180'} ${className}`} data-id="element-165">
    <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-12 md:h-20 block" data-id="element-166">
      <path d="M0,120 L1200,120 L1200,100 C1180,100 1170,70 1150,90 C1130,110 1120,50 1100,80 C1080,110 1070,60 1050,90 C1030,120 1020,40 1000,80 C980,120 970,60 950,90 C930,120 920,50 900,80 C880,110 870,40 850,70 C830,100 820,30 800,60 C780,90 770,50 750,80 C730,110 720,40 700,70 C680,100 670,60 650,90 C630,120 620,50 600,80 C580,110 570,70 550,100 C530,130 520,60 500,90 C480,120 470,50 450,80 C430,110 420,40 400,70 C380,100 370,60 350,90 C330,120 320,50 300,80 C280,110 270,40 250,70 C230,100 220,60 200,90 C180,120 170,50 150,80 C130,110 120,40 100,70 C80,100 70,60 50,90 C30,120 20,50 0,80 Z" fill={fill} data-id="element-167"></path>
    </svg>
  </div>;
export const WavyDivider = ({
  className = '',
  fill = '#FDFBF7',
  position = 'bottom'
}) => <div className={`absolute left-0 right-0 w-full overflow-hidden leading-none z-10 pointer-events-none ${position === 'bottom' ? 'bottom-0' : 'top-0 rotate-180'} ${className}`} data-id="element-168">
    <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-12 md:h-20 block" data-id="element-169">
      <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C73.23,23.3,153.19,43.3,228.3,50.7,259.6,53.8,290.9,56.44,321.39,56.44Z" fill={fill} data-id="element-170"></path>
    </svg>
  </div>;
export const LeafWatermark = ({
  className = ''
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-171">
    <path d="M12 22C12 22 20 18 20 12C20 6 12 2 12 2C12 2 4 6 4 12C4 18 12 22 12 22Z" data-id="element-172" />
    <path d="M12 22V2" stroke="currentColor" strokeWidth="0.5" data-id="element-173" />
  </svg>;
export const BranchDecoration = ({
  className = ''
}) => <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-174">
    <path d="M10 90 Q 40 60 90 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-175" />
    <path d="M30 70 Q 20 50 40 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-176" />
    <path d="M60 40 Q 70 20 50 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-177" />
    <circle cx="40" cy="40" r="4" fill="currentColor" data-id="element-178" />
    <circle cx="50" cy="10" r="4" fill="currentColor" data-id="element-179" />
    <circle cx="90" cy="10" r="5" fill="currentColor" data-id="element-180" />
  </svg>;
export const TopographicPattern = ({
  className = ''
}) => <div className={`absolute inset-0 pointer-events-none ${className}`} data-id="element-181">
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-182">
      <defs data-id="element-183">
        <pattern id="topo" width="100" height="100" patternUnits="userSpaceOnUse" data-id="element-184">
          <path d="M0 50 Q 25 25, 50 50 T 100 50" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.3" data-id="element-185" />
          <path d="M0 75 Q 25 50, 50 75 T 100 75" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.3" data-id="element-186" />
          <path d="M0 25 Q 25 0, 50 25 T 100 25" fill="none" stroke="currentColor" strokeWidth="0.5" opacity="0.3" data-id="element-187" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#topo)" data-id="element-188" />
    </svg>
  </div>;
export const LeafPattern = ({
  className = ''
}) => <div className={`absolute inset-0 pointer-events-none ${className}`} data-id="element-189">
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-190">
      <defs data-id="element-191">
        <pattern id="leaf-pattern" width="60" height="60" patternUnits="userSpaceOnUse" data-id="element-192">
          <path d="M30 45C30 45 40 35 40 25C40 15 30 10 30 10C30 10 20 15 20 25C20 35 30 45 30 45Z" fill="currentColor" opacity="0.1" data-id="element-193" />
          <path d="M30 45V10" stroke="currentColor" strokeWidth="0.5" opacity="0.1" data-id="element-194" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#leaf-pattern)" data-id="element-195" />
    </svg>
  </div>;